"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _tracking = require("settings-ui-app/utils/tracking");

var _EmailSettingsContainer = _interopRequireDefault(require("./containers/EmailSettingsContainer"));

var _AsyncContainers = require("./AsyncContainers");

var _default = _react.default.createElement(_reactRouter.Route, {
  path: "email",
  component: _EmailSettingsContainer.default
}, _react.default.createElement(_reactRouter.IndexRedirect, {
  to: "configuration"
}), _react.default.createElement(_reactRouter.Route, {
  path: "configuration",
  component: _AsyncContainers.AsyncConfigurationSettingsContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('configuration')
}), _react.default.createElement(_reactRouter.Route, {
  path: "double-opt-in",
  component: _AsyncContainers.AsyncDoubleOptInSettingsContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('double-opt-in')
}), _react.default.createElement(_reactRouter.Route, {
  path: "smtp",
  component: _AsyncContainers.AsyncSmtpSettingsContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('smtp')
}), _react.default.createElement(_reactRouter.Route, {
  path: "subscriptions",
  component: _AsyncContainers.AsyncSubscriptionsSettingsContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('subscriptions')
}), _react.default.createElement(_reactRouter.Route, {
  path: "tracking",
  component: _AsyncContainers.AsyncTrackingSettingsContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('tracking')
}), _react.default.createElement(_reactRouter.Route, {
  path: "types",
  component: _AsyncContainers.AsyncTypeSettingsContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('types')
}), _react.default.createElement(_reactRouter.Route, {
  path: "frequency",
  component: _AsyncContainers.AsyncSendFrequencyContainer,
  onEnter: (0, _tracking.trackScreenUsingSideNav)('frequency')
}));

exports.default = _default;
module.exports = exports.default;